// "Add to home screen" popup for people using the app in a browser tab. Android Chrome gets the
// browser's own install dialog; iOS and other Android browsers get the steps. "Not now" hides it
// for a week on this device.
import { useEffect, useState } from 'preact/hooks';
import { canInstall, install, isAndroid, isIOS, isStandalone, onInstallChange } from '../install';
import { load, save, KEYS } from '../storage';
import { useT } from '../i18n';
import { Phone } from '../icons';

const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
const DELAY_MS = 2500; // let the first screen settle before asking

export function InstallPrompt() {
  const t = useT();
  const [installable, setInstallable] = useState(canInstall());
  const [ready, setReady] = useState(false);
  const [closed, setClosed] = useState(() => Date.now() - load<number>(KEYS.installDismissed, 0) < SNOOZE_MS);
  useEffect(() => onInstallChange(() => setInstallable(canInstall())), []);
  useEffect(() => {
    const id = setTimeout(() => setReady(true), DELAY_MS);
    return () => clearTimeout(id);
  }, []);

  if (closed || !ready || isStandalone() || !(installable || isIOS() || isAndroid())) return null;
  const notNow = () => { save(KEYS.installDismissed, Date.now()); setClosed(true); };
  const how = installable ? t('auth.installBody') : isIOS() ? t('settings.installIOS') : t('install.android');
  return (
    <div class="scrim" role="dialog" aria-modal="true" aria-labelledby="install-title" onClick={(e) => e.target === e.currentTarget && notNow()}>
      <div class="sheet">
        <div class="sheet-handle" aria-hidden="true" />
        <div style="display:flex;gap:12px;align-items:flex-start">
          <span style="flex:none;width:44px;height:44px;border-radius:12px;background:var(--soft);display:flex;align-items:center;justify-content:center"><Phone /></span>
          <div style="display:flex;flex-direction:column;gap:4px">
            <h2 id="install-title" class="h2">{t('settings.install')}</h2>
            <div class="muted" style="font-size:15px;line-height:1.5">{how}</div>
          </div>
        </div>
        {installable
          ? <button class="btn btn-primary btn-lg" onClick={() => install().then(() => setClosed(true))}>{t('settings.installBtn')}</button>
          : null}
        <button class={installable ? 'btn btn-outline' : 'btn btn-primary btn-lg'} onClick={notNow}>{installable ? t('install.later') : t('common.done')}</button>
      </div>
    </div>
  );
}
